module.exports = __webpack_public_path__ + "static/media/c-pop-up-5.c7521fb4.png";